import * as yup from 'yup';

import state from '@hero/validators/state';
import {
    emailYupValidation,
    emailYupValidationNotRequired,
    phoneYupValidation,
    phoneYupValidationNotRequired
} from '../../../../../../../utils/validator';

const leadUpdateFormSchema = yup
    .object()
    .shape({
        is_member: yup.boolean().notRequired(),
        admin_email: emailYupValidationNotRequired,
        external_serial: yup.lazy((val?: string) => {
            if (!val) {
                return yup.string().trim().notRequired();
            } else {
                return yup.string().trim().required('External serial is required');
            }
        }) as unknown as yup.StringSchema<string, object>,
        first_name: yup.string().trim().required('First name is required'),
        last_name: yup.string().trim().required('Last name is required'),
        date_of_birth: yup.string().trim().required('Date of birth is required'),
        zip_code: yup
            .string()
            .trim()
            .matches(/^\d{5}$/, 'Invalid zip code'),
        patient_email: emailYupValidation,
        patient_phone: phoneYupValidation,
        external_user_id: yup.string().trim().notRequired(),
        caregiver_first_name: yup.string().trim().notRequired(),
        caregiver_last_name: yup.string().trim().notRequired(),
        email: emailYupValidationNotRequired,
        phone: phoneYupValidationNotRequired,
        insurance_type: yup.string().required('Insurance type is required'),
        insurance_company: yup.lazy((val) =>
            !val
                ? yup.string().trim().notRequired()
                : yup
                      .string()
                      .trim()
                      .matches(
                          /^[a-zA-Z0-9\s]+$/,
                          'Please ensure Insurance Company Name contains only alphanumeric characters (letters and numbers). Special characters are not allowed.'
                      )
        ),
        insurance_id: yup.lazy((val) =>
            !val
                ? yup.string().trim().notRequired()
                : yup
                      .string()
                      .trim()
                      .matches(
                          /^[a-zA-Z0-9\s]+$/,
                          'Please ensure Member ID contains only alphanumeric characters (letters and numbers). Special characters are not allowed.'
                      )
        ),
        medigap_insurance_name: yup.lazy((val) =>
            !val
                ? yup.string().trim().notRequired()
                : yup
                      .string()
                      .trim()
                      .matches(
                          /^[a-zA-Z0-9\s]+$/,
                          'Please ensure that Insurance Company Name contains only alphanumeric characters (letters and numbers). Special characters are not allowed.'
                      )
        ),
        medigap_insurance_policy_id: yup.lazy((val) =>
            !val
                ? yup.string().trim().notRequired()
                : yup
                      .string()
                      .trim()
                      .matches(
                          /^[a-zA-Z0-9\s]+$/,
                          'Please ensure Member ID contains only alphanumeric characters (letters and numbers). Special characters are not allowed.'
                      )
        ),
        address_line_1: yup
            .string()
            .trim()
            .notRequired()
            .test(
                'no-po-boxes',
                'P.O. Boxes are not allowed',
                (val) => !(val && /po\s*box/i.test(val))
            ),
        address_line_2: yup.string().trim().nullable(),
        city: yup.string().trim().notRequired(),
        state: yup.lazy((val) =>
            !val ? yup.string().trim().notRequired() : state
        ) as unknown as yup.StringSchema<string, object>,
        zip: yup.lazy((val) =>
            !val
                ? yup.string().trim().notRequired()
                : yup
                      .string()
                      .trim()
                      .matches(/^\d{5}$/, 'Invalid zip code')
        ) as unknown as yup.StringSchema<string, object>,
        isDirty: yup.boolean().default(false)
    })
    .defined();

export type LeadUpdateFormSchemaParams = yup.InferType<typeof leadUpdateFormSchema>;

export { leadUpdateFormSchema };
